import { useQuery } from '@tanstack/react-query';

import { Services } from '@/infra/services';
import { type ProductContext } from '@/infra/services/new-tail/model';
import { useGlobalStore } from '@/presenters/store/global';

const useProductsAds = (context: ProductContext, id: string) => {
  const {
    user: { resources },
  } = useGlobalStore((state) => state);

  const query = useQuery(
    ['products-ads', resources?.userTrackingId, context, id],
    async () => {
      if (!resources?.userTrackingId) return;

      return Services.NewTail.getProductsAds({
        context,
        sessionId: resources?.userTrackingId,
        userId: resources?.id,
      });
    },
    {
      enabled: Boolean(resources?.userTrackingId),
    }
  );

  return query;
};

export default useProductsAds;
